export const anmol = require('./anmol-avatar.jpeg');
export const gmeet = require('./gmeet-avatar.png');
export const jayde = require('./jayde-avatar.jpeg');
export const jeremy = require('./jeremy-avatar.jpeg');
export const matt = require('./matt-avatar.png');
export const neli = require('./neli-avatar.jpeg');
export const mike = require('./mike.png');
export const sung = require('./sung-avatar.jpeg');
export const wade = require('./wade-avatar.jpeg');
export const yamna = require('./yamna-avatar.jpeg');